import { useState } from 'react'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { Button, ClickAwayListener, MenuItem, MenuList, Paper, Popper } from '@mui/material'

export type LinesFilterValue = 'all' | 'open' | 'my'

export const LINES_FILTER = {
  ALL: 'all',
  OPEN: 'open',
  MY: 'my',
} as const satisfies Record<string, LinesFilterValue>

export const LINES_FILTER_OPTIONS: { label: string; value: LinesFilterValue }[] = [
  { label: 'All Lines', value: 'all' },
  { label: 'Open Lines', value: 'open' },
  { label: 'My Lines', value: 'my' },
]

type LinesFilterDropdownProps = {
  value: LinesFilterValue | null
  onChange: (value: LinesFilterValue) => void
  buttonClassName?: string
  paperClassName?: string
  menuItemClassName?: string
}

const LinesFilterDropdown = ({
  value,
  onChange,
  buttonClassName,
  paperClassName,
  menuItemClassName,
}: LinesFilterDropdownProps) => {
  // value === null means no filter selected
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const open = Boolean(anchorEl)

  const handleToggle = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl((prev) => (prev ? null : event.currentTarget))
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelect = (selected: LinesFilterValue) => {
    onChange(selected)
    setAnchorEl(null)
  }

  return (
    <>
      <Button
        className={buttonClassName}
        onClick={handleToggle}
        endIcon={<ArrowDropDownIcon />}
        aria-label="Filter lines"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        {value
          ? (LINES_FILTER_OPTIONS.find((o) => o.value === value)?.label ?? 'Filter Lines')
          : 'Filter Lines'}
      </Button>
      <Popper open={open} anchorEl={anchorEl} placement="bottom-end" style={{ zIndex: 1300 }}>
        <ClickAwayListener onClickAway={handleClose}>
          <Paper className={paperClassName} elevation={3}>
            <MenuList>
              {LINES_FILTER_OPTIONS.map((option) => (
                <MenuItem
                  key={option.value}
                  selected={value !== null && value === option.value}
                  onClick={() => handleSelect(option.value)}
                  className={menuItemClassName}
                >
                  {option.label}
                </MenuItem>
              ))}
            </MenuList>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  )
}

export default LinesFilterDropdown
